// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/package_provider_features_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/package_provider_features_response.proto.
 */
export const file_responses_v1_package_provider_features_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CjVyZXNwb25zZXMvdjEvcGFja2FnZV9wcm92aWRlcl9mZWF0dXJlc19yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxInYKH1BhY2thZ2VQcm92aWRlckZlYXR1cmVzUmVzcG9uc2USGwoTcGFja2FnZV9wcm92aWRlcl9pZBgBIAEoBBI2CghmZWF0dXJlcxgCIAMoDjIkLnJlc3BvbnNlcy52MS5QYWNrYWdlUHJvdmlkZXJGZWF0dXJlKl4KFlBhY2thZ2VQcm92aWRlckZlYXR1cmUSEgoOUEFDS0FHRV9QT0lOVFMQABIJCgVMQUJFTBABEg8KC0NPTUlOR19TT09OEAISFAoQQ0FTSF9PTl9ERUxJVkVSWRADQo8BChBjb20ucmVzcG9uc2VzLnYxQiRQYWNrYWdlUHJvdmlkZXJGZWF0dXJlc1Jlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message responses.v1.PackageProviderFeaturesResponse
 */
export type PackageProviderFeaturesResponse = Message<'responses.v1.PackageProviderFeaturesResponse'> & {
    /**
     * @generated from field: uint64 package_provider_id = 1;
     */
    packageProviderId: bigint;

    /**
     * @generated from field: repeated responses.v1.PackageProviderFeature features = 2;
     */
    features: PackageProviderFeature[];
};

/**
 * Describes the message responses.v1.PackageProviderFeaturesResponse.
 * Use `create(PackageProviderFeaturesResponseSchema)` to create a new message.
 */
export const PackageProviderFeaturesResponseSchema: GenMessage<PackageProviderFeaturesResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_package_provider_features_response, 0);

/**
 * @generated from enum responses.v1.PackageProviderFeature
 */
export enum PackageProviderFeature {
    /**
     * @generated from enum value: PACKAGE_POINTS = 0;
     */
    PACKAGE_POINTS = 0,

    /**
     * @generated from enum value: LABEL = 1;
     */
    LABEL = 1,

    /**
     * @generated from enum value: COMING_SOON = 2;
     */
    COMING_SOON = 2,

    /**
     * @generated from enum value: CASH_ON_DELIVERY = 3;
     */
    CASH_ON_DELIVERY = 3,
}

/**
 * Describes the enum responses.v1.PackageProviderFeature.
 */
export const PackageProviderFeatureSchema: GenEnum<PackageProviderFeature> =
    /*@__PURE__*/
    enumDesc(file_responses_v1_package_provider_features_response, 0);
